import React from "react";
import PersonForm from "../Personnel/PersonForm";
import ListScreen from "../common/ListScreen";

/**
 * Users & Access screens mirroring the production NewUsers / MasterSettings
 * AccessRight pages, built on the reusable Form/List components.
 */
const userFields = [
  { label: "First Name", placeholder: "Enter First Name" },
  { label: "Last Name", placeholder: "Enter last name" },
  { label: "Email ID", placeholder: "Enter Your Email ID" },
  { label: "Contact Number", placeholder: "Enter Your Contact Number" },
  { label: "Address", placeholder: "Enter Your Address", multiline: true },
];

export const CreateUser = () => (
  <PersonForm title="Create User" fields={userFields} submitLabel="Create" />
);
export const EditUser = () => (
  <PersonForm title="Edit User" fields={userFields} submitLabel="Update" />
);

export const AccessRight = () => (
  <ListScreen
    title="Access Right"
    search="Search Role..."
    addTo="AcessRole"
    items={[
      { title: "Administrator", subtitle: "Full access to all modules", to: "UserRole" },
      { title: "Fleet Manager", subtitle: "Vehicles, Trips, Drivers", to: "UserRole" },
      { title: "Transport Manager", subtitle: "Trips, Dispatch, Reports", to: "UserRole" },
      { title: "Operator", subtitle: "View-only access", to: "UserRole" },
    ]}
  />
);

export const AcessRole = () => (
  <PersonForm
    title="Create Access Role"
    submitLabel="Create"
    fields={[
      { label: "Role Name", placeholder: "Enter Role Name" },
      { label: "Description", placeholder: "Enter Description", multiline: true },
      { label: "Modules", placeholder: "Select Modules (Dashboard, Vehicles, Trips...)" },
      { label: "Permissions", placeholder: "View / Create / Edit / Delete" },
    ]}
  />
);

export const UserRole = () => (
  <PersonForm
    title="Assign User Role"
    submitLabel="Assign"
    fields={[
      { label: "User", placeholder: "Select User" },
      { label: "Role", placeholder: "Select Role" },
    ]}
  />
);
